// Generated by purs version 0.15.15
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
import * as Visonum_BulkPingApp_Imgs from "../Visonum.BulkPingApp.Imgs/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var view = function (props) {
    var elTitle = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("ErrorTitle")([ inline({
        gridArea: "Title",
        fontSize: "1.5em",
        fontWeight: "bold"
    }) ]);
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Error")([ inline({
        display: "grid",
        width: "100%",
        height: "100%",
        gridTemplateColumns: "1fr 40px",
        gridTemplateRows: "1fr 1fr",
        gap: "10px",
        gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"Title   Close\"", "\"Message Close\"" ]),
        fontFamily: "Arial"
    }) ]);
    var elMessage = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("ErrorMessage")([ inline({
        gridArea: "Message",
        fontSize: "10px",
        color: "black"
    }) ]);
    var elCloseIcon = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.img)("ErrorCloseIcon")([ inline({
        gridArea: "Close",
        cursor: "pointer",
        width: "30px",
        height: "30px"
    }) ]);
    return elRoot([  ])([ elTitle([  ])([ Halogen_Styled.text(props.title) ]), elMessage([  ])([ Halogen_Styled.text(props.message) ]), elCloseIcon([ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgCross), Halogen_HTML_Events.onClick(function (v) {
        return props.onClose;
    }) ]) ]);
};
export {
    view
};
//# sourceMappingURL=index.js.map
